import { FC } from "react";
import { Box, createStyles, makeStyles, Typography } from "@material-ui/core";
import { History as HistoryIcon } from "@material-ui/icons";

import { ownerLastActivityInformation } from "lib/date";
import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        justifyContent: "center",
      },
    },
    title: {
      fontWeight: theme.typography.fontWeightRegular,
      [theme.breakpoints.down("md")]: {
        fontSize: "1rem",
      },
    },
    info: {
      fontSize: "1.4rem",
      [theme.breakpoints.down("md")]: {
        fontSize: "1.2rem",
      },
    },
  }),
);

const OwnerLastActive: FC<{ ownerLastActiveDate: string }> = ({
  ownerLastActiveDate,
}) => {
  const classes = useStyles();
  const ownerLastActiveInfo = ownerLastActivityInformation(ownerLastActiveDate);

  return (
    <Box className={classes.container}>
      {ownerLastActiveInfo && (
        <>
          <HistoryIcon style={{ color: theme.custom.palette.green.main }} />
          <Box ml={2}>
            <Typography
              variant="h6"
              className={classes.title}
              gutterBottom={false}
            >
              Owner Last Active
            </Typography>
            <span className={classes.info}>{ownerLastActiveInfo}</span>
          </Box>
        </>
      )}
    </Box>
  );
};

export default OwnerLastActive;
